import { render, staticRenderFns } from "./RecebimentoParcialTabela.vue?vue&type=template&id=8e180d2a"
import script from "./RecebimentoParcialTabela.vue?vue&type=script&lang=js"
export * from "./RecebimentoParcialTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports